import React, { FC, memo, useCallback } from 'react';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { AppRoutes } from 'app/config/routerConfig/types';
import { useSpecialPromotionModal } from 'features/SpecialPromotion';
import { Button } from 'shared/ui/Button';
import NewWarehouseBanner from 'shared/assets/images/NewWarehouseBanner.png';
import NewWarehouseMobile from 'shared/assets/images/NewWarehouseMobile.png';
import { Trans } from 'react-i18next';
import { useScreenBreakpoints } from 'shared/utils/hooks/useScreenBreakpoints';

export const NewWarehousePromotionContent: FC = () => {
  const { t } = useAppTranslation('booking');
  const { isDesktop } = useScreenBreakpoints();

  // const currencySymbol = useGetCurrencySymbol();
  const { closeModal } = useSpecialPromotionModal();

  const goToBooking = useCallback(() => {
    window.location.href = `${AppRoutes.BOOKING}?warehouseId=4b44504c-ee19-4dbe-b077-e2f08a0b0e5b`;
    closeModal();
  }, [closeModal]);

  return (
    <div>
      <img src={isDesktop ? NewWarehouseBanner : NewWarehouseMobile} alt="Black friday promotion" className="min-h-[450px]" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 max-w-[280px] desktop:max-w-[800px] w-full bg-white p-6 text-center shadow-xl rounded-xl">
        {/* <div className="mb-3 flex justify-end">
          <Button theme="clear" className="text-black" onClick={closeModal}>
            {t('Close')}
          </Button>
        </div> */}
        <div className="mb-2 desktop:mb-7 text-[#0E518D] font-bold text-2xl desktop:text-4xl uppercase">
          {t('NEW OPENING IN {{warehoseName}}!', { warehoseName: 'MÜNCHEN-UNTERGIESING' })}
        </div>
        <div className="font-normal desktop:text-2xl text-black desktop:px-4">
          <Trans
            t={t}
            i18nKey="From <0>{{dateFrom}}</0> we offer dry, secure storage units in various sizes."
            components={[<span key="0" className="font-bold desktop:text-2xl text-black" />]}
            values={{ dateFrom: '25.03.2026' }}
          />
        </div>
        <div className="desktop:text-2xl my-2 text-[#E15501] font-bold underline">
          {t('Grand opening offer: 50% off for the first 3 months!')}
        </div>

        <Button
          theme="primary"
          fontSize={isDesktop ? 'large' : 'small'}
          onClick={goToBooking}
          className="!bg-[#E15501] mt-3"
          fontColor="text-white"
        >
          {t('Rent now and secure your discount!')}
        </Button>
      </div>
    </div>
  );
};
